import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {usePromotionStyle} from "../../../../promotion/components/Promotion";
import {getPromotionTypeName} from "../../../../promotion/helpers/PromotionType";
import {IVendorDetailPromotionOffer} from "../../../types/IVendorDetailPromotionOffer";

interface IProps {
    promotion: IVendorDetailPromotion;
    vendorSlug: string;
}

export interface IVendorDetailPromotion {
    name: string | null;
    id: number;
    offer: IVendorDetailPromotionOffer;
    type: number;
}

export const VendorDetailPromotionBox = (props: IProps) => {
    const {promotion} = props;
    const promotionStyle = usePromotionStyle(props.promotion.type);
    const offerLink = useOfferLink({
        ...promotion.offer,
        vendor: {slug: props.vendorSlug}
    });
    const {isMobile} = useUserDevice();

    const responsiveLinkTarget = useResponsiveLinkTarget();
    const offerAddress = getOfferAddress(promotion.offer);

    return (
        <a href={offerLink} target={responsiveLinkTarget} className={vendorDetailPromotionBoxStyle}>
            <ResponsiveCard
                cover={
                    <ResponsiveCard.ImgCover alt={promotion.offer.name} src={promotion.offer.main_image.m_img_375x211 || undefined} className={coverStyle} />
                }
                withCoverPadding
                coverDesktopPosition="left"
                coverWidthOnDesktop="352px"
                badges={
                    <>
                        <Text variant="mini_header" className={promotionTypeNameStyle} style={{backgroundColor: promotionStyle.color}}>
                            {getPromotionTypeName(promotion.type)}
                        </Text>
                        {isMobile ? (
                            <Text as="div" variant="headline_4">
                                {promotion.name}
                            </Text>
                        ) : null}
                    </>
                }
            >
                <ResponsiveCard.Body
                    header={
                        <>
                            <Text as="h3" variant={isMobile ? "headline_6" : "headline_4"} className={headerStyle}>
                                <span className={offerNameStyle}>{promotion.offer.name}</span>{" "}
                            </Text>
                            {!isMobile ? (
                                <Text as="div" variant="body_copy_2" className={css({mb: 2})}>
                                    {promotion.name}
                                </Text>
                            ) : null}
                        </>
                    }
                    text={isMobile ? offerAddress : null}
                >
                    <Button size="medium" type="button" variant="outlined_secondary">
                        ZOBACZ SZCZEGÓŁY
                    </Button>
                </ResponsiveCard.Body>
            </ResponsiveCard>
        </a>
    );
};

const getOfferAddress = (offer: IVendorDetailPromotionOffer) => {
    if (!offer || !offer.region || !offer.street_name) return "";

    return `${offer?.region?.short_name}${offer?.street_name ? `, ${offer.street_name}${offer.street_number ? ` ${offer.street_number}` : ""}` : ""}`;
};

const vendorDetailPromotionBoxStyle = css({
    display: "block",
    position: "relative",
    _hover: {
        textDecoration: "none",
        color: "var(--colors-secondary)"
    }
});

const coverStyle = css({
    height: "211px",
    maxWidth: "375px",
    width: "100%",
    md: {
        height: "211px",
        width: "336px"
    }
});

const headerStyle = css({
    paddingBottom: 2,
    display: "flex",
    flexDirection: "column"
});

export const promotionTypeNameStyle = css({
    textTransform: "uppercase",
    display: "inline-block",
    width: "fit-content",
    order: 0,
    mb: 2
});

const offerNameStyle = css({
    order: 1
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import ResponsiveCard from "../../../../atoms/responsive_card/ResponsiveCard";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {usePromotionStyle} from "../../../../promotion/components/Promotion";
import {getPromotionTypeName} from "../../../../promotion/helpers/PromotionType";
import {IVendorDetailPromotionOffer} from "../../../types/IVendorDetailPromotionOffer";

interface IProps {
    promotion: IVendorDetailPromotion;
    vendorSlug: string;
}

export interface IVendorDetailPromotion {
    name: string | null;
    id: number;
    offer: IVendorDetailPromotionOffer;
    type: number;
}

export const VendorDetailPromotionBox = (props: IProps) => {
    const {promotion} = props;
    const promotionStyle = usePromotionStyle(props.promotion.type);
    const offerLink = useOfferLink({
        ...promotion.offer,
        vendor: {slug: props.vendorSlug}
    });
    const {isMobile} = useUserDevice();

    const responsiveLinkTarget = useResponsiveLinkTarget();
    const offerAddress = getOfferAddress(promotion.offer);

    return (
        <a href={offerLink} target={responsiveLinkTarget} className={vendorDetailPromotionBoxStyle}>
            <ResponsiveCard
                cover={
                    <ResponsiveCard.ImgCover alt={promotion.offer.name} src={promotion.offer.main_image.m_img_375x211 || undefined} className={coverStyle} />
                }
                withCoverPadding
                coverDesktopPosition="left"
                coverWidthOnDesktop="352px"
                badges={
                    <>
                        <Text variant="mini_header" className={promotionTypeNameStyle} style={{backgroundColor: promotionStyle.color}}>
                            {getPromotionTypeName(promotion.type)}
                        </Text>
                        {isMobile ? (
                            <Text as="div" variant="headline_4">
                                {promotion.name}
                            </Text>
                        ) : null}
                    </>
                }
            >
                <ResponsiveCard.Body
                    header={
                        <>
                            <Text as="h3" variant={isMobile ? "headline_6" : "headline_4"} className={headerStyle}>
                                <span className={offerNameStyle}>{promotion.offer.name}</span>{" "}
                            </Text>
                            {!isMobile ? (
                                <Text as="div" variant="body_copy_2" className={css({mb: 2})}>
                                    {promotion.name}
                                </Text>
                            ) : null}
                        </>
                    }
                    text={isMobile ? offerAddress : null}
                >
                    <Button size="medium" type="button" variant="outlined_secondary">
                        ZOBACZ SZCZEGÓŁY
                    </Button>
                </ResponsiveCard.Body>
            </ResponsiveCard>
        </a>
    );
};

const getOfferAddress = (offer: IVendorDetailPromotionOffer) => {
    if (!offer || !offer.region || !offer.street_name) return "";

    return `${offer?.region?.short_name}${offer?.street_name ? `, ${offer.street_name}${offer.street_number ? ` ${offer.street_number}` : ""}` : ""}`;
};

const vendorDetailPromotionBoxStyle = css({
    display: "block",
    position: "relative",
    _hover: {
        textDecoration: "none",
        color: "var(--colors-secondary)"
    }
});

const coverStyle = css({
    height: "211px",
    maxWidth: "375px",
    width: "100%",
    md: {
        height: "211px",
        width: "336px"
    }
});

const headerStyle = css({
    paddingBottom: 2,
    display: "flex",
    flexDirection: "column"
});

export const promotionTypeNameStyle = css({
    textTransform: "uppercase",
    display: "inline-block",
    width: "fit-content",
    order: 0,
    mb: 2
});

const offerNameStyle = css({
    order: 1
});
